import { createFileRoute } from '@tanstack/react-router';

import { SparePartSheet } from '../../components/SparePartSheet/SparePartSheet';

export const Route = createFileRoute('/_auth/spare-part-sheet/$sparePartModelCode')({
  component: SparePartSheet,
});
